// jquery-global.js
import $ from 'jquery';
window.jQuery = $;
window.$ = $;
